/* eslint-disable */

declare var Object: any;
export interface HttpRequestInterface {
  id?: string;
  url: string;
  method: string;
  httpRequestId?: string;
  createdDate?: Date;
  createdBy?: string;
  createdById?: string;
  updatedDate?: Date;
  updatedBy?: string;
  updatedById?: string;
}

export class HttpRequest implements HttpRequestInterface {
  'id'?: string;
  'url': string;
  'method': string;
  'httpRequestId': string;
  'createdDate': Date;
  'createdBy': string;
  'createdById': string;
  'updatedDate': Date;
  'updatedBy': string;
  'updatedById': string;
  constructor(data?: HttpRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `HttpRequest`.
   */
  public static getModelName() {
    return 'HttpRequest';
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of HttpRequest for dynamic purposes.
   **/
  public static factory(data: HttpRequestInterface): HttpRequest {
    return new HttpRequest(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'HttpRequest',
      plural: 'HttpRequests',
      path: 'http-requests',
      idName: 'id',
      properties: {
        id: {
          name: 'id',
          type: 'string',
        },
        url: {
          name: 'url',
          type: 'string',
        },
        method: {
          name: 'method',
          type: 'string',
        },
        httpRequestId: {
          name: 'httpRequestId',
          type: 'string',
        },
        createdDate: {
          name: 'createdDate',
          type: 'Date',
        },
        createdBy: {
          name: 'createdBy',
          type: 'string',
        },
        createdById: {
          name: 'createdById',
          type: 'string',
        },
        updatedDate: {
          name: 'updatedDate',
          type: 'Date',
        },
        updatedBy: {
          name: 'updatedBy',
          type: 'string',
        },
        updatedById: {
          name: 'updatedById',
          type: 'string',
        },
      },
      relations: {},
    };
  }
}
